import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import CategoryHeader from "../../Components/Category/CategoryHeader";
import CardProductsContainer from "../../Components/Products/CardProductsContainer";
import Pagination from "../../Components/Utilities/Pagination";
import ViewAllProductsByCategoryHook from "../../hook/product/ViewAllProductsByCategoryHook";

import { Helmet } from "react-helmet";
import SideFilter from "../../Components/Utilities/SideFilter";
import ViewSearchProductHooks from "../../hook/product/ViewSearchProductHooks";
import LoadingSpinner from "../../Components/Utilities/LoadingSpinner";

const ProductsByCategory = () => {
  const { id } = useParams();
  const [, , , catById] = ViewAllProductsByCategoryHook(id);
  const [
    // items,
    // pagination,
    // onPress,
    // getProduct,
    // result,
    // offers,
    // selectedCategorySearch,
    // selectedBrandSearch,
    // search,
    // onChangeSetMinPrice,
    // onChangeSetMaxPrice,
    // minPrice,
    // maxPrice,
    // loadingSpinner,
    items,
    pagination,
    onPress,
    getProduct,
    result,
    ,
    selectedCategorySearch,
    selectedBrandSearch,
    search,
    onChangeSetMinPrice,
    onChangeSetMaxPrice,
    ,
    ,
    loadingSpinner,
    settingsRes,
    minPrice,
    maxPrice,
    searchBrand,
    ,
    searchCategories
  ] = ViewSearchProductHooks("", undefined, id);
  if (pagination) var pageCount = pagination;
  else pageCount = 0;

  let hideCategory = true;

  return (
    <div style={{ minHeight: "670px" }}>
      <Helmet>
        <title>
          {`  ${items[0]?.category.nameAr || " "} ${items[0] ? "-" : " "} ${
            settingsRes.data?.titleAr
          }`}{" "}
        </title>
      </Helmet>
      <CategoryHeader />
      <Container className="pt-4 pb-2">
        <div className="d-flex align-items-center" style={{ gap: '20px' }}>
          {catById?.image && (
            <div className="premium-brand-logo">
              <img
                src={catById?.image}
                alt="Category Logo"
              />
            </div>
          )}
          <div>
            <h1 className="premium-page-title">{catById?.nameAr}</h1>
            <p className="premium-page-subtitle text-muted mb-0">تصفح أحدث المنتجات والعروض المميزة</p>
          </div>
        </div>
        <hr className="mt-4 mb-2" style={{ borderColor: "rgba(0,0,0,0.05)" }} />
      </Container>
      <Container>
        <Row>
          <Col md="2" sm="2"  className="d-flex ">
            <SideFilter
              props={{
                selectedCategorySearch,
                selectedBrandSearch,
                search,
                onChangeSetMinPrice,
                onChangeSetMaxPrice,
                hideCategory,
                searchBrand
              }}
            />
          </Col>
          <Col md="10" sm="10" xs="12" >
            {loadingSpinner === true ? (
              <LoadingSpinner />
            ) : (
              <CardProductsContainer products={items} title="" btntitle="" />
            )}
          </Col>
        </Row>
       {
        items&&<Pagination pageCount={pageCount} onPress={onPress} />
       } 
      </Container>
    </div>
  );
};

export default ProductsByCategory;
